import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ProgressButtonComponent } from './progress-button/progress-button.component'
import { IconActionButtonComponent } from './icon-action-button/icon-action-button.component'

@NgModule({
  declarations: [ProgressButtonComponent, IconActionButtonComponent],
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule, MatTooltipModule],
  exports: [ProgressButtonComponent, IconActionButtonComponent],
})
export class UiButtonModule {}
